import { render } from "./Abbonamenti.vue?vue&type=template&id=0c57450e"
import script from "./Abbonamenti.vue?vue&type=script&lang=js"
export * from "./Abbonamenti.vue?vue&type=script&lang=js"
script.render = render

export default script